import { ReactComponent as FollowOutline } from 'assets/icons/icon-follow-outline.svg';

export default FollowOutline;
